// reload.service.ts

import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReloadService {
    private refreshCountKey = 'refreshCount';

  constructor() { }

  shouldRefreshScreen(): boolean {
    const refreshCount = parseInt(localStorage.getItem(this.refreshCountKey) || '0', 10);
    return refreshCount % 2 !== 0;
  }

  toggleRefreshCount(): void {
    let refreshCount = parseInt(localStorage.getItem(this.refreshCountKey) || '0', 10);
    refreshCount++;
    localStorage.setItem(this.refreshCountKey, refreshCount.toString());
  }
}
